import { IconMenuOption } from "../../interfaces/menu";

export const EXPORT_SELECTED_TO_EXCEL_LABEL = "Export Selected to Excel";
export const EXPORT_ALL_TO_EXCEL_LABEL = "Export All to Excel";

const EXPORT_LABELS = [EXPORT_SELECTED_TO_EXCEL_LABEL, EXPORT_ALL_TO_EXCEL_LABEL];

export function applyExportOnly(options: IconMenuOption[], exportOnly: boolean): IconMenuOption[] {
    if (!exportOnly) return options;
    return options.map(x => (EXPORT_LABELS.includes(x.label) ? x : { ...x, disabled: true }));
}
